<template>
  <div class="table-tab u-indent-m-b-45px">
    <div class="a-flex-space-between a-align-items-flex-end u-margin-b-24">
      <h3 class="u-font-size-22 u-color-black u-width-auto u-margin-0">{{$t('form.reports.summary-registry.title')}}</h3>
      <button class="gui-btn gui-btn--red gui-btn--w-150" @click.prevent="$emit('export')">
        {{$t('buttons.export')}}
      </button>
    </div>
    <section v-maximizable>
      <div class="table-tab__container" style="overflow: auto; outline: none;">
      <table class="table-tab__block table" style="min-width: 1500px" v-columns-resizable>
        <thead class="table-tab__thead">
          <tr class="">
            <th class="table-tab__border-right table-tab__border-bottom" >
              Наименование ТМЦ
            </th>
            <th class="table-tab__border-right table-tab__border-bottom" >
              Количество
            </th>
            <th class="table-tab__border-right table-tab__border-bottom">
              ЕИ
            </th>
            <th class="table-tab__border-right table-tab__border-bottom">
              Номер ЗП
            </th>
            <th class="table-tab__border-right table-tab__border-bottom">
              Текущий этап ЗП
            </th>
            <th class="table-tab__border-right table-tab__border-bottom">
              Дата Акцепта
            </th>
            <th class="table-tab__border-right table-tab__border-bottom">
              Поставщик
            </th>
          </tr>
        </thead>
        <tbody class="table-tab__tbody">
          <template v-for="(row, rowIdx) in grouppedReport">
            <tr>
              <td class="table-tab__border-right">
                {{row.nomen}}
              </td>
              <td class="table-tab__border-right">
                {{row.count}}
              </td>
              <td class="table-tab__border-right ">
                {{row.okei}}
              </td>
              <td class="table-tab__border-right">
                {{row.num}}
              </td>
              <td class="table-tab__border-right ">
                {{row.state}}
              </td>
              <td class="table-tab__border-right">
                <date-time tag="span"
                           :value="row.endTime"
                           :class="{
                             'calculated-time': !!row.calculateEndTime
                           }"></date-time>
              </td>
              <td class="table-tab__border-right ">
                {{row.organization}}
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    </section>
  </div>
</template>

<script>
  import LotState from '@/api/types/lot-state'

  export default {
    props: {
      report: Array,
      firstIndex: {
        type: Number,
        default: 0
      },
      lastIndex: {
        type: Number,
        default: 0
      }
    },

    components: {
      LotState
    },

    computed: {
      grouppedReport() {
        const page = _.cloneDeep(this.report.slice(this.firstIndex, this.lastIndex));

        if (!page[0].nomen) {
          for (let id = this.firstIndex; id >= 0; --id) {
            if (this.report[id].nomen) {
              page[0].nomen = this.report[id].nomen;
              break;
            }
          }
        }

        return page;
      }
    },

    methods: {
      lotState(state) {
        return new LotState(state).label;
      }
    }
  }
</script>

<style scoped>
  .calculated-time {
    color: #BBB;
    font-style: italic;
  }
</style>
